import { useSuspenseQuery } from "@tanstack/react-query";
import React from "react";
import { useLoaderData } from "react-router";

import type { InsightsLoaderReturn } from "../loader";
import { insightsRouteDataQuery, internalInsightsRouteDataQuery } from "../utils/route-data-query";

import Placeholder from "./placeholder";

export default function withPlaceholderFallback<TProps extends JSX.IntrinsicAttributes>(
  ComponentToRender: React.FC<TProps>
): React.FC<TProps> {
  return (props) => {
    const { customerDomain, internal }: InsightsLoaderReturn = useLoaderData();
    const {
      data: { hasWorkflowCompleted },
    } = useSuspenseQuery(
      (internal
        ? internalInsightsRouteDataQuery(customerDomain)
        : insightsRouteDataQuery(customerDomain)) as ReturnType<typeof insightsRouteDataQuery>
    );
    if (!hasWorkflowCompleted) {
      return <Placeholder />;
    }
    return <ComponentToRender {...props} />;
  };
}
